<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div
      v-if="loanScheduleSuccessCount.length || loanScheduleFailed.length"
      class="m-2"
    >
      <b-row>
        <b-col
          v-if="loanScheduleSuccessCount"
          md="6"
          class="mb-2"
        >
          <b-alert
            show
            variant="primary"
            class="p-2"
          >
            {{ loanScheduleSuccessCount }}
          </b-alert>
        </b-col>
        <b-col
          v-if="loanScheduleFailed.length"
          md="6"
          class="mb-2"
        >
          <div>
            <b-button variant="danger">
              {{ $t('FAILED LISTS') }}
            </b-button>
          </div>
          <b-table
            ref="loanScheduleFailedReport"
            :items="loanScheduleFailed"
            responsive
            :fields="failedHeaders"
            primary-key="id"
            show-empty
            :empty-text="$t('No records available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          /></b-col>
      </b-row>
    </div>

    <div class="m-2">
      <b-row>
        <b-col
          md="6"
          class="mb-2"
        >
          <validation-observer ref="dataMigrationLoanScheduleRules">
            <b-form>
              <b-col
                md="12"
                class="mb-2"
              >
                <div class="mb-1">
                  {{ $t('Select file (.xlsx format only)') }}
                </div>
                <b-form-file
                  id="file-name"
                  v-model="hasFileData"
                  :label="$t('Select file (.xlsx format only)')"
                  :state="Boolean(hasFileData)"
                  :placeholder="$t('Choose a file or drop it here...')"
                  :drop-placeholder="$t('Drop file here...')"
                  error-name="file"
                  rules="required"
                  accept=".xlsx"
                  @change="onChangeXLSX($event)"
                />
              </b-col>
            </b-form>
          </validation-observer>
        </b-col>

        <b-col
          md="6"
        >
          <b-row>
            <b-col
              md="5"
              class="mt-2"
            >
              <Button
                v-if="getUserPermission('DATA_MIGRATION') && parseExcelFile.length"
                :label="$t('Next >')"
                size="md"
                :hidden="isNextValidateHidden"
                :loading="isLoading"
                @click="handleNextValidate"
              />
              <Button
                v-if="getUserPermission('DATA_MIGRATION') && !errorMessages.length"
                :label="$t('Create Loan Schedule')"
                size="md"
                :hidden="isCreateBatchHidden"
                :loading="isLoading"
                :disabled="isDisabled"
                @click="handleCreate"
              />
            </b-col>
            <b-col
              md="7"
              class="mt-2"
            >
              <Button
                class="ml-2"
                align="end"
                :label="$t('Download Loan Schedule Migration Format')"
                size="md"
                icon="DownloadIcon"
                show-icon
                :loading="isLoading2"
                :disabled="isDisabled2"
                @click="handleDownloadSubmit"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-table
      v-if="errorMessages.length"
      ref="migrateLoanScheduleCreation"
      :items="errorMessages"
      responsive
      :fields="errorHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="position-relative"
    />
    <p
      v-if="totalSheetRows"
      class="p-2"
      style="font-size: 18px;"
    >
      {{ $t('There are total of') }} ({{ totalSheetRows }}) {{ $t('Records fetched') }}
    </p>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BForm, BTable, BFormFile, BButton, BAlert,
} from 'bootstrap-vue'
import { required } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
// import Papa from 'papaparse'
import XLSX from 'xlsx'
import Button from '../../../components/button/Button.vue'
import { toKobo } from '@/helpers/formatAmount'
import { batchAccountFormat, tableLessHeaders, tableAllHeaders } from '../../../../helpers/data'
import { toYearWithDate } from '../../../../helpers/formatDate'

export default {
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BForm,
    BFormFile,
    ValidationObserver,
    Button,
    BButton,
    BAlert,
  },
  filters: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      totalSheetRows: '',
      fileData: [],
      hasFileData: [],
      parseExcelFile: [],
      validatedExcelFileData: [],
      sortOrders: {},
      accountFormat: batchAccountFormat,
      successHeaders: tableAllHeaders,
      failedHeaders: tableLessHeaders,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'loanAccountNumber', sortable: true },
        { key: 'repaymentDueDate', sortable: true },
        { key: 'amount', sortable: true },
        { key: 'paymentType', sortable: true },
      ],
      required,
      isDisabled: false,
      isLoading: false,
      isDisabled2: false,
      isLoading2: false,
      showFormError: false,
      isCreateBatchHidden: true,
      isNextValidateHidden: false,
      loanScheduleSuccessCount: [],
      loanScheduleFailed: [],
      sortDesc: false,
      sortBy: 'lastName',
      errorHeaders: [
        { key: 'referenceNumber', sortable: true, label: 'Reference Number' },
        { key: 'message', sortable: true, label: 'Error Messages' },
      ],
      errorMessages: [],
    }
  },
  methods: {
    ...mapActions({
      migrateLoanScheduleCreation: 'batch/migrateLoanScheduleCreation',
      downloadAccountFormat: 'batch/downloadAccountFormat',
      validateLoanSheduleDataMigration: 'batch/validateLoanSheduleDataMigration',
    }),
    async handleCreate() {
      this.$refs.dataMigrationLoanScheduleRules.validate().then(success => {
        if (success) {
          this.confirm(this.migrateLoanScheduleAction, { text: this.$t('Are you sure you want to Create Batch Accounts?') })
        }
      })
    },
    async migrateLoanScheduleAction() {
      try {
        this.loanScheduleSuccessCount = ''
        this.showFormError = false
        this.isDisabled = true
        this.isLoading = true
        const formData = this.parseExcelFile.map(item => ({
          ...item,
          loanAccountNumber: item.loanAccountNumber ? item.loanAccountNumber.toString() : null,
          repaymentDueDate: item.repaymentDueDate ? toYearWithDate(item.repaymentDueDate) : null,
          amount: item.amount ? Number(toKobo(item.amount).toFixed()) : null,
          paymentType: item.paymentType ? Number(item.paymentType) : null,
        }))
        const response = await this.migrateLoanScheduleCreation(formData)
        const { status, data } = response
        if (status === 200) {
          this.hasFileData = []
          this.parseExcelFile = []
          if (data.successCount > 1) {
            const plural = this.$t('Loan Schedules was successfully created')
            this.loanScheduleSuccessCount = `(${data.successCount}) ${plural}`
          } else {
            const singular = this.$t('Loan Schedule was successfully created')
            this.loanScheduleSuccessCount = `(${data.successCount}) ${singular}`
          }
          this.loanScheduleFailed = data.failed
          this.isDisabled = false
          this.isLoading = false
        }
      } catch (error) {
        const errorText = this.$t('Your request to create Batch Loan Schedule failed. Reason')
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${errorText}: ${responseError.errorMessage}` })
        })
        this.showFormError = true
      } finally {
        this.isDisabled = false
        this.isLoading = false
      }
    },
    onChangeXLSX(event) {
      this.errorMessages = []
      this.isCreateBatchHidden = true
      this.fileData = event.target.files ? event.target.files[0] : null
      if (this.fileData) {
        const vm = this
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const rowObject = XLSX.utils.sheet_to_row_object_array(worksheet, { raw: false })
          vm.totalSheetRows = rowObject.length
          vm.parseExcelFile = JSON.parse(JSON.stringify(rowObject)).map(items => ({
            loanAccountNumber: items['Loan Account Number'],
            repaymentDueDate: items['Repayment Due Date'],
            amount: items.Amount,
            paymentType: items['Payment Type'],
          }))
        }
        reader.readAsBinaryString(this.fileData)
      }
    },
    async handleNextValidate() {
      try {
        this.isLoading = true
        this.hasFileData = []
        const formData = this.parseExcelFile.map(item => ({
          ...item,
          loanAccountNumber: item.loanAccountNumber ? item.loanAccountNumber.toString() : null,
          repaymentDueDate: item.repaymentDueDate ? toYearWithDate(item.repaymentDueDate) : null,
          amount: item.amount ? Number(toKobo(item.amount).toFixed()) : null,
          paymentType: item.paymentType ? Number(item.paymentType) : null,
        }))
        const response = await this.validateLoanSheduleDataMigration(formData)
        const { status, data } = response
        if (status === 200) {
          this.errorMessages = data.failed
          if (data.successCount > 1) {
            const pluralText = this.$t('Loan Schedules are ready to be created')
            this.loanScheduleSuccessCount = `(${data.successCount}) ${pluralText}`
          } else {
            const singularText = this.$t('Loan Schedule is ready to be created')
            this.loanScheduleSuccessCount = `(${data.successCount}) ${singularText}`
          }
          this.isCreateBatchHidden = false
          if (this.errorMessages.length) {
            this.isNextValidateHidden = false
          } else {
            this.isNextValidateHidden = true
            this.alertSuccess({ text: this.$t('Everything seems good! Continue with loan schedule data migration') })
          }
          this.isLoading = false
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const errorReasonText = this.$t('Your request to perform Batch Loan Schedule validation failed. Reason')
          this.alertError({
            text: `${errorReasonText}: ${responseError.errorMessage}`,
          })
        })
        this.isCreateBatchHidden = true
        this.isLoading = false
      }
    },
    async handleDownloadSubmit() {
      this.confirm(this.downloadAction, { text: this.$t('Are you sure you want to download Loan Account Data Migration Format?') })
    },
    async downloadAction() {
      try {
        this.isLoading2 = true
        this.isDisabled2 = true
        const LOAN_REPAYMENT_SCHEDULE_MIGRATION_TEMPLATE = 11
        const response = await this.downloadAccountFormat(LOAN_REPAYMENT_SCHEDULE_MIGRATION_TEMPLATE)
        if (response.status === 200) {
          const downloadAnchor = document.createElement('a')
          downloadAnchor.setAttribute('href', response.data.data)
          const filename = 'Udara360-Loan-Schedule-Data-Migration.xlsx'
          downloadAnchor.setAttribute('download', filename)
          document.body.appendChild(downloadAnchor)
          downloadAnchor.click()
          document.body.removeChild(downloadAnchor)
          this.alertSuccess({ text: this.$t('Your request to download Loan Schedule Data Migration Format was successful') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Your request to download Loan Schedule Data Migration Format failed. Reason')
          this.alertError({ text: `${reasonText}: ${responseError.errorMessage}` })
          this.isLoading2 = false
          this.isDisabled2 = false
        })
      } finally {
        this.isLoading2 = false
        this.isDisabled2 = false
      }
    },
  },
}
</script>
